// src/routes/Lvl1Router.jsx
import React, { Suspense, lazy } from "react";
import { ClipLoader } from "react-spinners"; // ✨ spinner

const RecordingLvl1 = lazy(() => import("recordingLvl1/App"));

export default function Lvl1Router(props) {
  return (
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingLvl1 {...props} />
    </Suspense>
  );
}
